import React from 'react'
import { HiCheck, HiClock, HiX } from 'react-icons/hi'

export const STEP_TONE = {
  done: { icon: <HiCheck />, className: 'bg-success-500 text-white' },
  waiting: { icon: <HiClock />, className: 'bg-gray-700 text-gray-300' },
  failed: { icon: <HiX />, className: 'bg-red-500 text-white' },
}

/**
 * One step of a vertical status tracker (Submitted → Approved, as in the
 * withdrawal and top-up detail dialogs). Steps draw the connecting line down
 * to the next one, except the `last`.
 */
const TrackerStep = ({ tone = 'done', title, detail, last }) => (
  <div className="relative flex gap-3 pb-5 last:pb-0">
    {!last && <span className="absolute left-[13px] top-7 bottom-0 w-px bg-[#30363d]" />}
    <span className={`relative flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm ${STEP_TONE[tone].className}`}>
      {STEP_TONE[tone].icon}
    </span>
    <div className="min-w-0 pt-0.5">
      <div className="text-sm font-semibold text-gray-100">{title}</div>
      {detail && <div className="text-xs text-gray-400">{detail}</div>}
    </div>
  </div>
)

export default TrackerStep
